// JsFromRoutes CacheKey 1dcf248565596009570f2b818c46a86b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_links/search'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/category_links/typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/category_links'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/category_links'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/category_links/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/category_links/:id'),
}
